"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[695],{

/***/ 50695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SvgLinkedin = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.774.048C.794.048 0 .815 0 1.76v20.48c0 .946.795 1.712 1.774 1.712h20.452c.98 0 1.774-.767 1.774-1.712V1.76c0-.945-.794-1.712-1.774-1.712H1.774Zm5.52 9.243v10.761H3.701V9.291h3.591Zm.236-3.328c0 1.032-.78 1.859-2.032 1.859h-.023c-1.206 0-1.985-.827-1.985-1.86 0-1.056.803-1.859 2.032-1.859 1.228 0 1.985.803 2.008 1.86Zm5.342 14.09h-3.59s.046-9.752 0-10.762h3.59v1.523c.478-.733 1.332-1.776 3.237-1.776 2.363 0 4.134 1.539 4.134 4.844v6.17h-3.59v-5.756c0-1.447-.52-2.434-1.82-2.434-.992 0-1.583.666-1.842 1.309-.095.229-.119.551-.119.872v6.01Z",
  fill: "currentColor"
})));
/* harmony default export */ __webpack_exports__["default"] = (SvgLinkedin);

/***/ })

}]);